import "react-circular-progressbar/dist/styles.css";
import { SCORE_THRESHOLDS } from "../../services/detect";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import {
	ExclamationCircleIcon,
	DocumentTextIcon,
	UserIcon,
} from "@heroicons/react/24/outline";

interface DetectDescriptionProps {
	value: number; // 0-1
}

const getScoreDescription = (
	score: number,
): {
	title: string;
	Icon: React.ElementType;
	description: string;
} => {
	if (score >= SCORE_THRESHOLDS.mostlyAi)
		//65-100
		return {
			title: "High AI Detection",
			Icon: ExclamationCircleIcon,
			description:
				"This document shows strong indicators of AI-generated content. Multiple sections display patterns consistent with artificial intelligence writing.",
		};
	if (score >= SCORE_THRESHOLDS.mostlyHuman)
		//25-64
		return {
			title: "Average AI Detection",
			Icon: DocumentTextIcon,
			description:
				"This document shows a mix of human and AI-generated content. Some sections may have been written or heavily edited by AI, while others appear to be authored by a human.",
		};
	if (score < 0.01)
		return {
			title: "No AI Content Detected",
			Icon: UserIcon,
			description:
				"This document shows no signs of AI-generated content. The analysis found no patterns consistent with artificial intelligence writing.",
		};
	return {
		//1-24
		title: "Low AI Detection",
		Icon: UserIcon,
		description:
			"This document appears to be primarily human-written. The analysis found few signs of AI-generated content, suggesting that the writing style, structure, and language are consistent with authentic human authorship.",
	};
};

export function DetectDescription({ value }: DetectDescriptionProps) {
	const { title, description, Icon } = getScoreDescription(value);

	return (
		<Alert variant="default" className="bg-gray-50">
			<Icon />
			<AlertTitle>{title}</AlertTitle>
			<AlertDescription>
				<p>{description}</p>
			</AlertDescription>
		</Alert>
	);
}
